import { SubscriptionStatus } from "../enums";  
import { SystemColor, SystemColorsModel } from "../models";

export class SubscriptionUtil {
  static getColorsByStatus(
    status: keyof typeof SubscriptionStatus
  ): SystemColor {
    let colors = SystemColorsModel.lightGreyColors();
    switch (status) {
      case "Inactive":
        colors = SystemColorsModel.lightGreyColors();
        break;
      case "Active":
        colors = SystemColorsModel.lightBlueColor();
        break;
      case "PastDue":
        colors = SystemColorsModel.lightRedColor();
        break;
      case "Paused":
        colors = SystemColorsModel.lightOrangeColors();
        break;
      case "Pending":
        break;
    }
    return colors;
  }
}
